import { Injectable } from '@angular/core';
import { Query } from '@examdojo/state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PayoutAccountStoreModel, PayoutAccountUIModel } from './payout-account.model';
import { PayoutAccountState, PayoutAccountStore } from './payout-account.store';

@Injectable({
  providedIn: 'root',
})
export class PayoutAccountQuery extends Query<PayoutAccountState> {
  constructor(protected override readonly store: PayoutAccountStore) {
    super(store);
  }

  selectPayoutAccount(): Observable<PayoutAccountUIModel | null> {
    return this.select('payoutAccount').pipe(map((account) => (account ? this.mapToUIModel(account) : null)));
  }

  selectHasPayoutAccount(): Observable<boolean> {
    return this.select('payoutAccount').pipe(map((account) => !!account));
  }

  selectLoading(): Observable<boolean> {
    return this.select('loading');
  }

  selectError(): Observable<unknown> {
    return this.select('error');
  }

  getPayoutAccount(): PayoutAccountUIModel | null {
    const account = this.getValue().payoutAccount;
    return account ? this.mapToUIModel(account) : null;
  }

  hasPayoutAccount(): boolean {
    return !!this.getValue().payoutAccount;
  }

  private mapToUIModel(account: PayoutAccountStoreModel): PayoutAccountUIModel {
    return {
      ...account,
      isSetupComplete: !!(account.recipient_name && account.recipient_currency),
    };
  }
}
